<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <!-- <router-link :to="{ name: 'languageStore' }" class="btn btn-success">Добавить язык</router-link> -->
            <h4 class="pull-right">Языки</h4>
          </header>
          <div class="card-body">
            <table
              class="table table-bordered table-striped"
              id="serverDataTable"
            >
              <thead>
                <tr>
                  <th>Язык</th>
                  <th>Первый заглавную</th>
                  <th>Все заглавную</th>
                  <th>Подчеркивание</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(unit, index) in languages" :key="index">
                  <td>{{ unit.lang }}</td>
                  <td>{{ unit.firstCapital }}</td>
                  <td>{{ unit.capital }}</td>
                  <td>{{ unit.plural }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET } from "../../shared/api";
export default {
  data() {
    return {
      languages: [],
    };
  },
  methods: {
    getLanguages() {
      GET([], "/language", this, false).then((response) => {
        this.languages = response;
      });
    },
  },
  mounted() {
    this.getLanguages();
  },
};
</script>
